const ignoreErrors = [
    // Freshchat warning
    'Freshchat widget not available',
    // user got a 401 error, which is expected if they're not logged in
    'Request failed with status code 401',
    // user got a 403 error, which is expected if they're not logged in
    'Request failed with status code 403',
    // Intentionally triggered to prevent route change when unsaved changes are present
    'Please ignore this error.'
];

const sentryConfig = {
    dsn: process.env.SENTRY_DSN,
    release: process.env.VERSION,
    environment: process.env.SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    sourcemaps: {
        disable: true
    },
    ignoreErrors
};

export default sentryConfig;
